import BranchList from "@/3_view/pages/BranchList/BranchList";
import KeywordList from "@/3_view/pages/KeywordList/KeywordList";
import KeywordsManagement from "@/3_view/pages/KeywordsManagement/KeywordsManagement";
import RankByBranch from "@/3_view/pages/RankByBranch/RankByBranch";
import Root from "@/Root";
import VueRouter from "vue-router";
import Vue from 'vue'
import RankByKeyword from "@/3_view/pages/RankByKeyword/RankByKeyword";



Vue.use(VueRouter);

let hostPath = process.env.VUE_APP_ROUTER_HOST_PATH

let currentPath = window.location.href
let isDemoPage = currentPath.indexOf("/demo/") !== -1;
isDemoPage ? hostPath = '/demo' + hostPath : null;

const routes = [
    {
        path: hostPath,
        name: 'Root',
        component: Root,
        pathToRegexpOptions: { strict: true },
        props: { "isDemoPage": isDemoPage }
    },
    {
        path: hostPath + 'branches/',
        name: 'BranchList',
        component: BranchList,
        pathToRegexpOptions: { strict: true },
        props: { "isDemoPage": isDemoPage }
    },
    {
        path: hostPath + 'keywords/',
        name: 'KeywordList',
        component: KeywordList,
        pathToRegexpOptions: { strict: true },
        props: { "isDemoPage": isDemoPage }
    },
    {
        path: hostPath + 'rank_by_branch/:id/',
        name: 'RankByBranch',
        component: RankByBranch,
        pathToRegexpOptions: { strict: true },
        props: { "isDemoPage": isDemoPage }
    },
    {
        path: hostPath + 'rank_by_keyword/', // TODO Если поставить :id/, то API вернет 404
        name: 'RankByKeyword',
        component: RankByKeyword,
        pathToRegexpOptions: { strict: true },
        props: { "isDemoPage": isDemoPage }
    },
    {
        path: hostPath + 'keywords_management/',
        name: 'KeywordsManagement',
        component: KeywordsManagement,
        pathToRegexpOptions: { strict: true },
        props: { "isDemoPage": isDemoPage }
    },
    {
        path: hostPath + 'page-not-found/',
        alias: '*',
        component: { render: (h) => h("div", ["404! Page Not Found!"]) },
    },
];

const router = new VueRouter({
    routes,
    mode: 'history',
    base: '/',
});

// router.beforeEach((to, from, next) => {
//     /* необходимо вызывать `next` */
//     console.log('beforeEach', from, to)
//     next()
// })
//
// router.beforeResolve((to, from, next) => {
//     /* необходимо вызывать `next` */
//     console.log('beforeResolve', from, to)
//     next()
// })
//
// router.afterEach((to, from) => {
//     console.log('afterEach', from, to)
// })


export default router